import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import SearchFilter from "./searchFilter.js";

function mapStateToProps(state) {
  return {
    domainDetails: state.domainDetails,
    simulatedUserDetails: state.simulatedUserDetails,
    isSimulateMode: state.isSimulateMode,
    userDetails: state.userDetails,
    searchTxnAccountDropdowns: state.searchTxnAccountDropdowns,
    searchObj: state.searchObj,
    texts: state.translatedTexts,
    machines: state.machines,
    dealerAccount: state.dealerAccount,
    searchPageComponents: state.searchPageComponents,
    relatedAccount: state.relatedAccount
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilter);
